var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatBubbleTextSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1258_1492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.06641 8.064H18.0336",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06641 13.6512H14.712",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.84795 21.1392L1.19995 22.8L2.86075 17.8152V2.8632C2.86044 2.6447 2.90324 2.42828 2.98671 2.22635C3.07018 2.02441 3.19268 1.84094 3.34719 1.68643C3.50169 1.53193 3.68517 1.40943 3.8871 1.32596C4.08903 1.24249 4.30545 1.19968 4.52395 1.2H21.1392C21.5796 1.2 22.0021 1.37498 22.3135 1.68644C22.625 1.9979 22.8 2.42033 22.8 2.8608V19.476C22.8003 19.6943 22.7575 19.9105 22.6742 20.1123C22.5909 20.3141 22.4686 20.4974 22.3144 20.6519C22.1601 20.8064 21.9769 20.9289 21.7753 21.0125C21.5736 21.0962 21.3575 21.1392 21.1392 21.1392H7.84795Z",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1258_1492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubbleTextSquare);
export default __webpack_public_path__ + "static/media/chat-bubble-text-square.7bca6ad7a8e35e9e70de7e02e3fb11ed.svg";
export { ForwardRef as ReactComponent };